// eslint-disable-next-line
import { Stats } from "react-instantsearch-dom";

const initState = {
    booleanPublishNewCoursesModalIsOpen: false,
    booleanPublishNewCoursesSecondModalIsOpen: false,
    booleanPublishStatsModalIsOpen: false,
    highlightedPublishCourseCID: null,
    Screen: null,
    highlightedPublishCourse: null,
    PublishCourseSchool: '',
    booleanArea1Submitted: false,
    price: 1,
    booleanArea3Submitted: false,
    booleanArea2Submitted: false,
    booleanArea4Submitted: false,
    booleanPublishStatsModalMenuIsOpen: false,
    CID: 'empty',

};

const publishReducer = (state=initState, action) => {
    
    switch (action.type) {

        case 'SAVE_STRIPE_CONNECT_ACCOUNT':

            return{
                
            }


        case 'SAVE_STRIPE_CONNECT_ACCOUNT_ERROR':
            return{

            }


        case 'PUBLISH_MODALS':
            return{
                ...state,
                booleanPublishNewCoursesModalIsOpen: action.booleanPublishNewCoursesModalIsOpen,
                booleanPublishStatsModalIsOpen: action.booleanPublishStatsModalIsOpen,
                Screen: action.Screen,
                highlightedPublishCourseCID: null,
                highlightedPublishCourse: null,
                PublishCourseSchool: '',
                booleanArea1Submitted: false,
                price: 1,
                booleanArea3Submitted: false,
                booleanArea2Submitted: false,
            }



        case 'PUBLISH_COURSE':
            
            return{
                ...state,
                Screen: action.Screen,
                highlightedPublishCourseCID: action.highlightedPublishCourseCID,
                highlightedPublishCourse: action.highlightedPublishCourse,
                PublishCourseSchool: '',
                booleanArea1Submitted: false,
                price: 1,
                booleanArea3Submitted: false,
                booleanArea2Submitted: false,
            }

        case 'PUBLISH_SECOND_MODAL':
            return{
                ...state,
                Screen: action.Screen,
                booleanPublishNewCoursesModalIsOpen: action.booleanPublishNewCoursesModalIsOpen,
                booleanPublishNewCoursesSecondModalIsOpen: action.booleanPublishNewCoursesSecondModalIsOpen,
                booleanArea4Submitted: action.booleanArea4Submitted,

            }

        case 'PUBLISH_SECOND_MODAL_TO_FIRST':
            return{
                ...state,
                Screen: action.Screen,
                booleanPublishNewCoursesSecondModalIsOpen: action.booleanPublishNewCoursesSecondModalIsOpen,
                booleanArea2Submitted: action.booleanArea2Submitted,
                booleanArea3Submitted: action.booleanArea3Submitted,
                booleanArea4Submitted: action.booleanArea4Submitted,
                price: action.price,
            }
    
        case 'PUBLISH_COURSE_AREA_2':
            return{
                ...state,
                PublishCourseSchool: action.PublishCourseSchool,
                booleanArea2Submitted: action.booleanArea2Submitted,
            }

        case 'PUBLISH_COURSE_AREA_3':
            return{
                ...state,
                Screen: action.Screen,
                booleanArea3Submitted: action.booleanArea3Submitted,
                booleanArea4Submitted: action.booleanArea4Submitted,
            }

        case 'PUBLISH_COURSE_AREA_4':
            return{
                ...state,
                Screen: action.Screen,
                price: action.price,
                booleanArea4Submitted: action.booleanArea4Submitted,
            }

        case 'PUBLISH_STATS_ACCORDIAN_MENU_IS_OPEN':
            return{
                ...state,
                booleanPublishStatsModalMenuIsOpen: action.booleanPublishStatsModalMenuIsOpen,
            }

        case 'PUBLISH_STATS_ACCORDIAN_MENU':
            return{
                ...state,
                CID: action.CID,
            }

        default:
            return state;
           
    }

}



export default publishReducer

